module.exports = __webpack_public_path__ + "static/media/base.5d17eedc.png";